
import Header from '../../../components/LayoutContest/Header/Header';
import classes from '../ContestPage.module.css';

export function ContestLoading() {
  return (
    <div className={classes.contestPage}>
      <Header />
      <div className={classes.loadingContainer}>
        <div className={classes.loadingSpinner}>⏳</div>
        <p>טוען נתונים...</p>
      </div>
    </div>
  );
}

export function ContestError({ error }) {
  return (
    <div className={classes.contestPage}>
      <Header />
      <div className={classes.errorContainer}>
        <p className={classes.errorText}>{error}</p>
      </div>
    </div>
  );
}
